import { useState, useEffect } from "react";

import { Auth } from "aws-amplify";

import styles from "./Auth.module.css";

import ReactGA from "react-ga";

import { Screens } from "types/general";
import ConfirmAccount from "./ConfirmAccount";
type Errors = {
	email: string;
	password: string;
};

interface Props {
	onSuccess: () => void;
	setScreen: (v: Screens) => void;
}
export default function Login({ onSuccess, setScreen }: Props) {
	const [errorMessage, setErrorMessage] = useState<string>(null!);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmAccount, setConfirmAccount] = useState(false);
	const [loading, setLoading] = useState(false);
	const [fieldErrors, setFieldErrors] = useState<Errors>({
		email: null!,
		password: null!,
	});
	useEffect(() => {
		ReactGA.pageview("login_page");
	}, []);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		setErrorMessage(null!);
		setFieldErrors({
			email: null!,
			password: null!,
		});

		let res = validateFields();
		if (res.success) {
			signIn();
		} else {
			setFieldErrors(res.errors);
		}
	};
	const validateFields = () => {
		const errors: Errors = {
			email: null!,
			password: null!,
		};
		let errorFound = false;
		if (email === "") {
			errorFound = true;
			errors.email = "Please enter your email address";
		} else {
			// Validate the email with a regex
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			// const res =
			// 	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!emailRegex.test(email)) {
				errorFound = true;
				errors.email = "Email is invalid";
			}
		}

		if (password === "") {
			errorFound = true;
			errors.password = "Please enter your password";
		}

		if (!errorFound) {
			return {
				success: true,
				errors: null!,
			};
		} else {
			return {
				success: false,
				errors: errors,
			};
		}
	};

	const signIn = async () => {
		setLoading(true);
		await Auth.signIn(email, password)

			.then((res) => {
				setLoading(false);

				onSuccess();
			})

			.catch((err) => {
				switch (err.code) {
					case "PasswordResetRequiredException":
						// dispatch(setCurrentModal("reset_password"));
						break;
				}
				switch (err.message) {
					case "User is not confirmed.":
						resendConfirmationCode();
						break;
					case "User does not exist.":
						setErrorMessage("User does not exist.");

						break;
					case "Attempt limit exceeded, please try after some time.":
						setErrorMessage("Attempt limit exceeded, please try again later.");
						break;
					case "Incorrect username or password.":
						setErrorMessage("Incorrect username or password.");
						break;

					default:
						setErrorMessage("There was a problem logging you in.");
				}
				setLoading(false);
			});
	};

	async function resendConfirmationCode() {
		try {
			await Auth.resendSignUp(email);
			setConfirmAccount(true);
		} catch (error) {
			setErrorMessage("There was a problem logging you in.");
		}
	}

	return (
		<div className={styles.formWrapper}>
			{confirmAccount ? (
				<ConfirmAccount onSuccess={onSuccess} email={email} password={password} />
			) : (
				<>
					<h3 className="text-body fs-3">SIGN IN TO YOUR ACCOUNT</h3>
					{errorMessage ? <span className={styles.errorMessage}>{errorMessage}</span> : null}
					<form className={styles.loginForm} onSubmit={handleSubmit} autoComplete="on">
						<div className={styles.inputGroup}>
							<label className="text-body">EMAIL</label>
							<input
								autoFocus
								type="email"
								className="text-dark"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="EMAIL"
								autoComplete="on"
							/>
							{fieldErrors.email !== null ? <span className={styles.errorMessage}>{fieldErrors.email}</span> : null}
						</div>
						<div className={styles.inputGroup}>
							<label className="text-body">PASSWORD</label>
							<input
								value={password}
								className="text-dark"
								onChange={(e) => setPassword(e.target.value)}
								type="password"
								placeholder="PASSWORD"
								autoComplete="on"
							/>
							{fieldErrors.password !== null ? (
								<span className={styles.errorMessage}>{fieldErrors.password}</span>
							) : null}
						</div>

						<button
							type="button"
							onClick={() => setScreen("update_password")}
							className="btn btn-link align-self-end text-primary"
						>
							Forgot password?
						</button>

						<button className="btn btn-primary w-100 mt-4" type="submit" disabled={loading}>
							{loading ? "LOGGING IN..." : "LOGIN"}
						</button>
					</form>

					<p className="text-muted mt-2 d-flex align-items-center">
						Don't have an account?
						<button
							type="button"
							className="btn btn-link text-primary m-0 p-0 ms-2"
							onClick={() => setScreen("register")}
						>
							Register here
						</button>
					</p>
				</>
			)}
		</div>
	);
}
